import { useEffect, useState } from 'react';
import { requestAnimationFrame, cancelAnimationFrame } from '@umu/umu-util';

export function useRaf(currentTime: number, maxDuration: number) {
    const [value, setValue] = useState(0);
    useEffect(() => {
        let animationId: number;
        let duration = 0;
        const step = () => {
            if (duration > maxDuration) {
                cancelAnimationFrame(animationId);
                return;
            }

            duration += 16;
            setValue(currentTime + duration);
            animationId = requestAnimationFrame(step);
        };
        setValue(currentTime);
        animationId = requestAnimationFrame(step);
        return () => {
            cancelAnimationFrame(animationId);
        };
    }, [currentTime]);

    return value;
}
